export const capitalize = (string: string) => (string ? string.charAt(0).toUpperCase() + string.slice(1) : '');

export const shortenPublicKey = (publicKey: string) => {
  if (publicKey?.length < 10) {
    return '';
  } else {
    return `${publicKey?.substring(0, 6)}...${publicKey?.substring(publicKey?.length - 4, publicKey.length)}`;
  }
};
